import type { ModuleTransformer } from '../types';
import type { SingleOccurrenceFormType } from './SingleOccurrenceForm';

export const fromPayload: ModuleTransformer<SingleOccurrenceFormType>['fromPayload'] = ({
  lottery,
}) => {
  return {
    startDate: lottery.occurrence.startDate,
    endDate: lottery.occurrence.endDate,
    drawDay: lottery.drawDay,
    drawTime: lottery.drawTime,
  };
};
